<template>
  <!-- <div class="text-center"> -->
  <v-toolbar-items class="tbar-items" :light="!darkTheme" :dark="darkTheme">
    <!-- <v-fade-transition > -->
    <v-row
      justify="center"
      v-show="!drawer"
      transition="slide-y-transition"
      reverse-transition="slide-y-reverse-transition"
    >
      <v-col cols="8" class="pa-0">
        <v-dialog v-model="dialogTopMnu" fullscreen transition="fade-transition">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="mx-2 pa-2 subtitle-1 btn-mnu cursor-url">МАГАЗИНЫ</span>
            <!-- <v-btn  color="white" light  v-on="on" class="mx-2 subtitle-1 btn-mnu">МАГАЗИНЫ</v-btn> -->
          </template>
          <v-card  class="full-menu expan-panel-accord" tile>
            <v-toolbar dark color="black">
              <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
              <v-toolbar-title>МАГАЗИНЫ</v-toolbar-title>
              <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
              <v-btn icon dark @click="dialogTopMnu = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-row class="pa-0 mx-0 block-menu" justify="center" align="center">
              <v-col cols="12" class="pa-0 expan-panel-accord">
                <v-row class="ma-0 pa-0 " justify="end" align="end">
                  <!--  <v-expansion-panels  dark accordion class="expan-panel-accord d-flex justify-start" v-model="panel"> -->
                  <v-col v-for="shi in grpShop.length" :key="`cat-`+shi" cols="4" class="pa-0 ">
                    <v-btn
                      color="white"
                      text
                      block
                      dark
                      @click="bSheet1(shi-1)"
                    >{{ grpShop[shi-1].namesubcat}}</v-btn>

                    <!--                   <v-expansion-panel class="expan-panel">
                    <v-expansion-panel-header>{{ grpShop[shi-1].namesubcat}}</v-expansion-panel-header>
                      <v-expansion-panel-content class="text-left" >                       
                        <v-list dense class="list-itm">
                          <v-list-item-group  color="primary">
                            <v-list-item v-for="(cShopItem ,insh) in grpShop[shi-1].objects" :key="`cat-`+insh">
                              <v-list-item-content >
                                <v-list-item-title @click="goToPage('/'+loadPathData.mnuShopsPath+'/',cShopItem)" >{{cShopItem.title}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>-->
                  </v-col>
                  <!--  </v-expansion-panels> -->
                </v-row>
              </v-col>
            </v-row>

            <!-- 

          <v-row class="pa-0 mx-0 block-menu">
            <v-col cols="4" class="pa-0">
              <v-expansion-panels dark accordion class="expan-panel-accord" v-model="panel">
                    <v-expansion-panel v-for="shi in 8" :key="`cat-`+shi" class="expan-panel">
                      <v-expansion-panel-header>{{ grpShop[shi-1].namesubcat}}</v-expansion-panel-header>
                      <v-expansion-panel-content class="text-left">
                        <v-list dense class="list-itm">
                          <v-list-item-group  color="primary">
                            <v-list-item v-for="(cShopItem ,insh) in grpShop[shi-1].objects" :key="`insh-`+insh">
                              <v-list-item-content>
                                <v-list-item-title @click="goToPage('/'+loadPathData.mnuShopsPath+'/',cShopItem)" >{{cShopItem.title}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
              </v-expansion-panels>

            </v-col>
            <v-col cols="4" class="pa-0" >
              <v-expansion-panels dark accordion class="expan-panel-accord"  v-model="panel1">
                    <v-expansion-panel v-for="shi in 8" :key="`cat-`+shi"  class="expan-panel">
                      <v-expansion-panel-header>{{ grpShop[7+shi].namesubcat}}</v-expansion-panel-header>
                      <v-expansion-panel-content class="text-left">
                        <v-list dense class="list-itm">
                          <v-list-item-group  color="primary"  class="expan-panel">
                            <v-list-item v-for="(cShopItem ,insh) in grpShop[7+shi].objects" :key="`insh-`+insh">
                              <v-list-item-content>
                                <v-list-item-title  @click="goToPage('/'+loadPathData.mnuShopsPath+'/',cShopItem)" >{{cShopItem.title}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <v-col cols="4"  class="pa-0">
              <v-expansion-panels dark accordion class="expan-panel-accord" v-model="panel2">
                    <v-expansion-panel v-for="shi in 4" :key="`cat3-`+shi" class="expan-panel">
                      <v-expansion-panel-header>{{ grpShop[15+shi].namesubcat}}</v-expansion-panel-header>
                      <v-expansion-panel-content class="text-left">
                        <v-list dense class="list-itm">
                          <v-list-item-group  color="primary">
                            <v-list-item v-for="(cShopItem ,insh) in grpShop[15+shi].objects" :key="`insh-`+insh">
                              <v-list-item-content>
                                <v-list-item-title  @click="goToPage('/'+loadPathData.mnuShopsPath+'/',cShopItem)" >{{cShopItem.title}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            </v-row>-->

            <v-row class="ma-0 pa-0" justify="center" v-if="selectShopsGrp">
              <v-col
                v-for="(cShopItemS ,ink) in selectGrpShops"
                :key="`catd-`+ink"
                cols="1"
                class="cursor-url"
              >
                <v-img
                  :src="cShopItemS.anchor_logo"
                  @click="goToPage('/'+loadPathData.mnuShopsPath+'/',cShopItemS)"
                  v-if="cShopItemS.anchor_logo!==null"
                ></v-img>
                <v-row class="fill-height ma-0" align="center" justify="center" v-else>
                  <v-progress-circular indeterminate color="grey darken-1"></v-progress-circular>
                </v-row>
              </v-col>
            </v-row>

            <!--           <BottomLogo /> -->
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogTopMnu2" fullscreen hide-overlay transition="fade-transition">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="mx-2 pa-2 subtitle-1 btn-mnu cursor-url">РЕСТОРАНЫ И КАФЕ</span>
            <!-- <v-btn  color="white" light  v-on="on" class="mx-2 subtitle-1 btn-mnu">Рестораны и кафе</v-btn> -->
          </template>
          <v-card v-if="allCafe.length > 1" class="full-menu expan-panel-accord" tile>
            <v-toolbar dark color="black">
              <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
              <v-toolbar-title>РЕСТОРАНЫ И КАФЕ</v-toolbar-title>
              <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
              <v-btn icon dark @click="dialogTopMnu2 = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <!--           <v-row class="pa-0  mx-0 block-menu"  justify="center" align="center">
            <v-col cols="12" class="pa-0 expan-panel-accord" >
              <v-expansion-panels dark accordion class="expan-panel-accord" v-model="panel">
                    <v-expansion-panel v-for="shi in 2" :key="`cat-`+shi" class="expan-panel">
                      <v-expansion-panel-header>{{ grpCafe[shi-1].namesubcat}}</v-expansion-panel-header>
                      <v-expansion-panel-content class="text-left">
                        <v-list dense class="list-itm">
                          <v-list-item-group  color="primary">
                            <v-list-item v-for="(cShopItem ,insh) in grpCafe[shi-1].objects" :key="`insh-`+insh">
                              <v-list-item-content>
                                <v-list-item-title @click="goToPage('/'+loadPathData.mnuCafePath+'/',cShopItem)" >{{cShopItem.title}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
              </v-expansion-panels> 

             
            </v-col>
            </v-row>-->
            <v-row class="ma-0 pa-0" justify="center">
              <v-col
                v-for="(cShopItemC ,insh) in allCafe"
                :key="`insh-`+insh"
                cols="1"
                class="cursor-url"
              >
                <!--  <v-btn block  text @click="goToPage('/'+loadPathData.mnuCafePath+'/',cShopItemC)" dark class="white--text text-notransform"> {{cShopItemC.title}}</v-btn> -->
                <v-img
                  :src="cShopItemC.anchor_logo"
                  @click="goToPage('/'+loadPathData.mnuCafePath+'/',cShopItemC)"
                  v-if="cShopItemC.anchor_logo!==null"
                ></v-img>

                <v-row class="fill-height ma-0" align="center" justify="center" v-else>
                  <v-progress-circular indeterminate color="grey darken-1"></v-progress-circular>
                </v-row>
              </v-col>
            </v-row>
            <!-- <BottomLogo :listShops="allCafe"/> -->
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogTopMnu3" fullscreen hide-overlay transition="fade-transition">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="mx-2 pa-2 subtitle-1 btn-mnu cursor-url">РАЗВЛЕЧЕНИЯ</span>
            <!-- <v-btn   color="white" light v-on="on" class="mx-2 subtitle-1 btn-mnu">Развлечения</v-btn> -->
          </template>
          <v-card v-if="grpEntertaitment.length > 2" class="full-menu expan-panel-accord" tile>
            <v-toolbar dark color="black">
              <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
              <v-toolbar-title>РАЗВЛЕЧЕНИЯ</v-toolbar-title>
              <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
              <v-btn icon dark @click="dialogTopMnu3 = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <!--           <v-row class="pa-0 mx-0  block-menu"  justify="center" align="center">
            <v-col cols="12" class="expan-panel-accord ">


            </v-col>
            </v-row>-->
            <v-row class="ma-0 pa-0"  justify="center">
              <v-col
                v-for="(cShopItemE ,insh) in grpEntertaitment"
                :key="`insh-`+insh"
                cols="1"
                class="cursor-url"
              >
                <!-- <v-btn block  text @click="goToPage('/'+loadPathData.mnuEntertatmentPath+'/',cShopItemE)" dark class="white--text"> {{cShopItemE.title}}</v-btn> -->
                <v-img
                  :src="cShopItemE.anchor_logo"
                  @click="goToPage('/'+loadPathData.mnuEntertatmentPath+'/',cShopItemE)"
                  v-if="cShopItemE.anchor_logo!==null"
                ></v-img>

                <v-row class="fill-height ma-0" align="center" justify="center" v-else>
                  <v-progress-circular indeterminate color="grey darken-1"></v-progress-circular>
                </v-row>
              </v-col>
            </v-row>
            <!--           <BottomLogo /> -->
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialogTopMnu4" fullscreen hide-overlay transition="fade-transition">
          <template v-slot:activator="{ on }">
            <span v-on="on" class="mx-2 pa-2 subtitle-1 btn-mnu cursor-url">УСЛУГИ</span>
            <!-- <v-btn color="white" light v-on="on" class="mx-2 subtitle-1 btn-mnu">Услуги</v-btn> -->
          </template>
          <v-card class="full-menu expan-panel-accord" tile>
            <v-toolbar dark color="black">
              <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
              <v-toolbar-title>УСЛУГИ</v-toolbar-title>
              <v-spacer v-if="$vuetify.breakpoint.smAndUp"></v-spacer>
              <v-btn icon dark @click="dialogTopMnu4 = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>

            <v-row class="pa-0 mx-0 block-menu" justify="center" align="center">
              <v-col cols="12" class="pa-0 expan-panel-accord">
                <v-row class="ma-0 pa-0">
                  <v-expansion-panels dark accordion class="expan-panel-accord" v-model="panel">
                    <v-col
                      v-for="shi in grpServices.length"
                      :key="`insh-`+shi"
                      cols="4"
                      class="pa-0"
                    >
                      <v-btn
                        color="white"
                        text
                        block
                        dark
                        @click="bSheet2(shi-1)"
                      >{{ grpServices[shi-1].namesubcat}}</v-btn>

                      <!-- 
                  <v-expansion-panel class="expan-panel">
                    <v-expansion-panel-header>{{ grpServices[shi-1].namesubcat}}</v-expansion-panel-header>
                      <v-expansion-panel-content class="text-left" >                       
                        <v-list dense class="list-itm">
                          <v-list-item-group  color="primary">
                            <v-list-item v-for="(cShopItem ,insh) in grpServices[shi-1].objects" :key="`insh-`+insh">
                              <v-list-item-content >
                                <v-list-item-title @click="goToPage('/'+loadPathData.mnuServicePath+'/',cShopItem)" >{{cShopItem.title}}</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-expansion-panel-content>
                      </v-expansion-panel>-->
                    </v-col>
                  </v-expansion-panels>
                  <!-- 
                      <v-bottom-sheet v-model="sheet2" persistent>

                        <v-sheet class="expan-panel-accord" min-height="200px">
                          <v-btn
                            class="mt-6"
                            text
                            color="error"
                            @click="sheet2 = !sheet2"
                          >Закрыть</v-btn>

                          <v-row justify="center" align="center">
                            <v-col cols="2" v-for="(cShopItem ,insh) in grpServices[currSHI].objects" :key="`insh-`+insh">
                                  <v-btn text color="white" class="list-itm" @click="goToPage('/'+loadPathData.mnuServicePath+'/',cShopItem)">{{cShopItem.title}}</v-btn>
                            </v-col>
                          </v-row>

                        </v-sheet>
                  </v-bottom-sheet>-->
                </v-row>
              </v-col>
            </v-row>

            <v-row class="ma-0 pa-0" justify="center">
              <v-col
                v-for="(cShopItemSC ,insh) in selectGrpShopsServ"
                :key="`inshp-`+insh"
                cols="1"
                class="cursor-url"
              >
                <v-img
                  :src="cShopItemSC.anchor_logo"
                  @click="goToPage('/'+loadPathData.mnuServicePath+'/',cShopItemSC)"
                  v-if="cShopItemSC.anchor_logo!==null"
                ></v-img>
                <v-row class="fill-height ma-0" align="center" justify="center" v-else>
                  <v-progress-circular indeterminate color="grey darken-1"></v-progress-circular>
                </v-row>
              </v-col>
            </v-row>

            <!-- <BottomLogo /> -->
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <!-- </v-fade-transition> -->

    <!-- 

    <v-bottom-sheet hide-overlay v-model="sheet1">
      <v-sheet class="expan-panel-accord" min-height="200px">
        <v-btn class="mt-6" text color="error" @click="sheet1 = !sheet1">Закрыть</v-btn>

        <v-row justify="center" align="center" v-if="selectShopsGrp">
          <v-col cols="2" v-for="(cShopItem ,insh) in grpShop[currSHI].objects" :key="`cat-`+insh">
            
            <v-btn
              text
              color="white"
              class="list-itm text-notransform"
              @click="goToPage('/'+loadPathData.mnuShopsPath+'/',cShopItem)"
            >{{cShopItem.title}}</v-btn>
          </v-col>
        </v-row>

        <v-row justify="center" align="center" v-else>
          <v-col
            cols="2"
            v-for="(cShopItem ,insh) in grpServices[currSHI].objects"
            :key="`insh-`+insh"
          >
            
            <v-btn
              text
              color="white"
              class="list-itm text-notransform"
              @click="goToPage('/'+loadPathData.mnuServicePath+'/',cShopItem)"
            >{{cShopItem.title}}</v-btn>
          </v-col>
        </v-row>
      </v-sheet>
    </v-bottom-sheet>-->
  </v-toolbar-items>

  <!-- </div> -->
</template>
<script>
import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import router from "vue-router";
import BottomLogo from "@/components/BottomLogo";
Vue.use(Vuex);

export default {
  name: "TopFullMenu",
  components: {
    BottomLogo,
  },
  data() {
    return {
      selectShopsGrp: true,
      currSHI: 0,
      sheet1: false,
      sheet2: false,
      panel: null,
      panel1: null,
      panel2: null,
      dialogTopMnu: false,
      dialogTopMnu2: false,
      dialogTopMnu3: false,
      dialogTopMnu4: false,
      isService: false,
      selectGrpShops: null,
      selectGrpShopsServ: null,
      grpShop: [],
      grpCafe: [],
      allCafe: [],
      grpEntertaitment: [],
      grpServices: [],
      arrLogoBottom: ["94", "233", "166", "117"],
    };
  },

  computed: {
    isDebug:{
      get() {
        return this.$store.state.app.isDebug;
      },
    },    
    darkTheme: {
      get() {
        return this.$store.state.app.darkTheme;
      },
      set(value) {
        this.$store.dispatch("setTheme", value);
      },
    },
    loadPathData: {
      get() {
        return this.$store.getters.getLoadPathData;
      },
    },
    shops: {
      get() {
        return this.$store.state.shops.shops;
      },
    },
    drawer: {
      get() {
        return this.$store.state.menu.drawer;
      },
      set(val) {
        let vApp = this;
        vApp.$store.dispatch("updateDrawer", val);
      },
    },
  },
  watch: {
    dialogTopMnu(nSel) {
      let vApp = this;

      if(DEBUG) console.log("nSel :>> ", nSel);
      if (!nSel) {
        vApp.panel = vApp.panel1 = vApp.panel2 = null;
      }
    },
  },
  methods: {
    bSheet1(shi) {
      const vApp = this;
      if(DEBUG) console.log("shi :>> ", shi);
      vApp.selectShopsGrp = true;
      //  vApp.sheet1 = true;
      //  vApp.currSHI = shi;
      if(DEBUG) console.log("grpShop[currSHI].objects :>> ", vApp.grpShop[6].objects);
      vApp.selectGrpShops = vApp.grpShop[shi].objects;
      if(DEBUG) console.log("grpShop[currSHI].objects :>> ", vApp.selectGrpShops);
    },
    bSheet2(shi) {
      const vApp = this;
      if(DEBUG) console.log("shi :>> ", shi);
      vApp.selectShopsGrp = false;
      //  vApp.sheet1 = true;
      //  vApp.currSHI = shi;
      vApp.selectGrpShopsServ = vApp.grpServices[shi].objects;
    },
    getLogoUrl(idSH) {
      let vApp = this;
      if(DEBUG) console.log("idSH :", idSH);
      if(DEBUG) console.log("vApp.shops :", vApp.shops);
      return vApp.shops.find((shpl) => shpl.id === idSH).logourl;
    },
    goToPage(preurl, url) {
      let vApp = this;
      if(DEBUG) console.log("id url :", url);
      if(DEBUG) console.log("id path :", vApp.$route.name);
      vApp.currentShop = url;
      vApp.$router.push(preurl + url.slug);
      vApp.dialogTopMnu = false;
      /*       if(vApp.$route.name === 'SingleShop'){
      this.$router.push('/shops/'+url).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })   
      this.$router.go();     
        //vApp.loadCurrentShop(url);
      }
      else{
      this.$router.push('/shops/'+url).catch(error => {
        if (error.name !== 'NavigationDuplicated') {
          throw error
        }
      })
      } */
    },
  },

  mounted() {
    let vApp = this;
    this.$nextTick(function () {
      if(DEBUG) console.log("this.$store TopFullMenu :", vApp.$store);
      vApp.panel = vApp.panel1 = vApp.panel2 = null;
      vApp.isService = false;
      axios({
        method: "get",
        url:
          "http://api.trcgagarinsky.ru/terminal__tmp/index.php/js/get_categories_with_shops",
      })
        .catch(function (error) {
          if(DEBUG) console.log("ERROR: ", error);
        })
        .then(function (response) {
          if(DEBUG) console.log("response dataAll Category = ", response.data);

          vApp.$store.dispatch("updateCategory", response.data);

          vApp.grpShop = response.data[0].category;
          vApp.grpCafe = response.data[1].category;
          vApp.allCafe.push(vApp.grpCafe[0].objects);
          vApp.allCafe.push(vApp.grpCafe[1].objects);          
          vApp.allCafe = [...vApp.allCafe[0], ...vApp.allCafe[1]];
          
          vApp.allCafe = [...response.data[1].objects]
          vApp.grpEntertaitment = response.data[2].objects;
          vApp.grpServices = response.data[3].category.filter(
            (itser) => itser.objects.length !== 0
          );
          vApp.isService = true;
          if(DEBUG) console.log("vApp.isService :", vApp.isService);
        });

      /*     var elem = document.getElementsByTagName('html');
    var lastClassName = '';
    window.setInterval( function() {   
       var className = 'overflow-y-hidden';
        if (className !== lastClassName) {
             if(DEBUG) console.log('className :>> ', className);
             elem[0].classList.remove("overflow-y-hidden");
            //lastClassName = className;
        }
    },10); */

      if(DEBUG) console.log("logourl :", vApp.shops);
      if(DEBUG) console.log(
        "logourl :",
        vApp.shops.find((shpl) => shpl.id === "117").logourl
      );
      //if(DEBUG) console.log('logourl :', vApp.shops.find(shpl => shpl.id === vApp.arrLogoBottom[2]));
    });
  },
};
</script>


<style scoped>
.expan-panel-accord {
  background-color: #3339;
  backdrop-filter: blur(5px);
}
.theme--dark.v-list {
  background: transparent;
}
.expan-panel {
  background: transparent;
}

.full-menu {
  background: #333333aa;
  /*   background: url('../assets/background/night.jpg') no-repeat center;
  background-size: cover;
  background-color: transparent; */
}
.theme--dark.v-expansion-panels .v-expansion-panel,
.list-itm,
.theme--light.v-list {
  background: transparent;
}

.btn-mnu:hover {
  /* background-color: #999 !important; */
  color: #fff;
  border-bottom: 2px #fff solid;
}
button.btn-mnu:hover {
  background-color: #999 !important;
  color: #fff;
}
.block-menu {
  margin-top: 0px;
}
.bottom-logo {
  width: 100%;
  position: absolute;
  bottom: 10px;
}
.text-notransform {
  text-transform: none;
}
</style>